import * as React from "react";

export const useSet = (defaultValue: string[] = []) => {
  const [array, setArray] = React.useState<string[]>(defaultValue);

  const set = React.useMemo(() => new Set(array), [array]);

  const add = React.useCallback((value: string) => {
    setArray(prev => {
      const newSet = new Set(prev);
      newSet.add(value);
      return Array.from(newSet);
    });
  }, []);

  const remove = React.useCallback((value: string) => {
    setArray(prev => {
      const newSet = new Set(prev);
      newSet.delete(value);
      return Array.from(newSet);
    });
  }, []);

  const toggle = React.useCallback((value: string) => {
    setArray(prev => {
      const newSet = new Set(prev);
      if (newSet.has(value)) {
        newSet.delete(value);
      } else {
        newSet.add(value);
      }
      return Array.from(newSet);
    });
  }, []);

  const setValues = React.useCallback((values: string[] | Set<string>) => {
    setArray(Array.from(values));
  }, []);

  const updateMany = React.useCallback((values: string[], shouldAdd: boolean) => {
    setArray(prev => {
      const newSet = new Set(prev);
      values.forEach(value => {
        if (shouldAdd) {
          newSet.add(value);
        } else {
          newSet.delete(value);
        }
      });
      return Array.from(newSet);
    });
  }, []);

  const clear = React.useCallback(() => {
    setArray([]);
  }, []);

  return {
    set,
    array,
    add,
    remove,
    toggle,
    setValues,
    updateMany,
    clear,
  };
};
